export default "__VITE_ASSET__CACuFy2I__"